import b from "./design-system.es58.js";
import { resolveComponent as u, openBlock as g, createElementBlock as N, normalizeClass as z, withModifiers as h, createElementVNode as i, withDirectives as a, createVNode as c, vShow as d, createTextVNode as n, toDisplayString as p, createBlock as T, withCtx as S, createCommentVNode as x } from "vue";
/* empty css                    */
/* empty css                    */
import I from "./design-system.es128.js";
/* empty css                    */
import k from "./design-system.es62.js";
import C from "./design-system.es59.js";
/* empty css                    */
/* empty css                    */
import _ from "./design-system.es89.js";
import w from "./design-system.es116.js";
/* empty css                    */
import L from "./design-system.es37.js";
/* empty css                    */
import { useEventListener as v } from "./design-system.es125.js";
/* empty css                    */
const V = {
  name: "DsFileUploadInput",
  components: {
    Box: L,
    Icon: b,
    IconButton: C,
    Inline: k,
    ProgressBar: _
  },
  props: {
    /**
     * File accept type
     */
    accept: {
      type: String,
      default: "*"
    },
    /**
     * Instructions for the user
     */
    instructions: String,
    /**
     * Upload file label
     */
    label: String,
    /**
     * Allowed files label
     */
    allowedFilesLabel: String,
    /**
     * Text to display after upload completes
     */
    uploadCompleteLabel: String,
    /**
     * Maximum file size in bytes
     */
    maxFileSizeBytes: {
      type: Number,
      default: 0
    },
    /**
     * value of the file uploaded
     */
    modelValue: [Object, File]
  },
  emits: [
    "error",
    "update:modelValue"
  ],
  setup() {
    const t = w();
    function e(r) {
      r.preventDefault();
    }
    return v("drop", e), v("dragover", e), { i18n: t };
  },
  data() {
    return {
      uploadStarted: !1,
      complete: !1,
      success: !1,
      error: !1,
      errorMessage: "",
      fileSize: 0,
      fileName: "",
      file: this.modelValue,
      fileBeingDragged: !1
    };
  },
  computed: {
    fileSizeLabel() {
      return this.formatBytes(this.fileSize);
    },
    shortFileName() {
      return /[.]/.exec(this.fileName) ? this.fileName.replace(/.[^.]+$/, "") : "";
    },
    fileType() {
      const t = this.fileName.toLowerCase();
      return /[.]/.exec(t) ? /[^.]+$/.exec(t)[0] : "";
    }
  },
  methods: {
    browse() {
      !this.complete && !this.fileName && this.$refs.fileInput.click();
    },
    handleDrop({ dataTransfer: t, target: e }) {
      this.reset(), e === this.$refs.dropzone && (this.fileBeingDragged = !1, this.handleSelectedFiles(t));
    },
    handleSelection({ target: t }) {
      t && this.handleSelectedFiles(t);
    },
    handleSelectedFiles({ files: t = [], items: e = [] }) {
      const r = t.length || e.length, o = t[0] || e[0] || null;
      r > 1 ? this.$emit("error", "multipleFiles") : o ? o.kind === "file" ? this.filesChanged(o.getAsFile()) : this.filesChanged(o) : this.$emit("error", "fileNotDefined");
    },
    handleDragenter({ target: t }) {
      t === this.$refs.dropzone && (this.fileBeingDragged = !0);
    },
    handleDragleave({ target: t }) {
      t === this.$refs.dropzone && (this.fileBeingDragged = !1);
    },
    filesChanged(t) {
      if (this.validateFile(t), !this.error) {
        this.uploadStarted = !0;
        const { name: e, size: r } = t;
        this.fileName = e, this.fileSize = r, this.sendFile(t);
      }
    },
    validateFile(t) {
      this.error = this.validateFileSize(t) || this.validateFileType(t);
    },
    validateFileSize({ size: t }) {
      const e = t > this.maxFileSizeBytes && this.maxFileSizeBytes > 0;
      return e && this.$emit("error", "fileSize"), e;
    },
    validateFileType({ type: t, name: e }) {
      if (this.accept === "*")
        return !1;
      const [r, o] = t.split("/"), l = this.getFileGroupsThatAcceptAllTypes();
      if (r && l.includes(r))
        return !1;
      const s = this.getAcceptedFileTypes();
      if (o && s.includes(o))
        return !1;
      const m = /[.]/.exec(e) ? /[^.]+$/.exec(e)[0] : "";
      return m && s.includes(m) ? !1 : (this.$emit("error", "fileType"), !0);
    },
    getFileGroupsThatAcceptAllTypes(t = this.accept) {
      const e = /(?:^|[^,|\s])+?(?=\/\*{1})/gi;
      return t.match(e) || [];
    },
    getAcceptedFileTypes(t = this.accept) {
      const e = /([^.|/|*])+?(?=,|$)/gi;
      return t.match(e) || [];
    },
    formatBytes(t) {
      if (t === 0)
        return "0KB";
      const e = 1e3, r = ["B", "KB", "MB", "GB"], o = Math.floor(Math.log(t) / Math.log(e));
      return parseFloat((t / e ** o).toFixed(0)) + r[o] || 0;
    },
    reset() {
      this.fileName = "", this.fileSize = 0, this.complete = !1, this.success = !1, this.error = !1, this.errorMessage = "", this.uploadStarted = !1, this.$refs.fileInput.value = null, this.$emit("update:modelValue", null);
    },
    sendFile(t) {
      this.$emit("update:modelValue", t);
    }
  }
}, A = { class: "no-pointer-events" }, M = { class: "circle" }, G = {
  id: "initial-info",
  class: "no-pointer-events"
}, E = { class: "label semibold" }, P = { class: "instructions" }, K = { class: "allowedFilesLabel" }, U = {
  id: "info",
  class: "no-pointer-events"
}, j = { ref: "fileForm" }, O = ["accept"], q = { id: "details" }, H = { class: "file-name" }, J = { class: "short-name" }, Q = { class: "file-size" }, R = { id: "progress-bar-container" }, W = { id: "status" };
function X(t, e, r, o, l, s) {
  const m = u("Icon"), F = u("ProgressBar"), B = u("IconButton"), y = u("Box"), D = u("Inline");
  return g(), N("div", {
    ref: "dropzone",
    class: z(["file-upload", {
      success: l.success || l.fileName,
      dragging: l.fileBeingDragged,
      clickable: !l.fileName
    }]),
    onClick: e[1] || (e[1] = (...f) => s.browse && s.browse(...f)),
    onDrop: e[2] || (e[2] = h((...f) => s.handleDrop && s.handleDrop(...f), ["prevent"])),
    onDragenter: e[3] || (e[3] = h((...f) => s.handleDragenter && s.handleDragenter(...f), ["prevent"])),
    onDragleave: e[4] || (e[4] = h((...f) => s.handleDragleave && s.handleDragleave(...f), ["prevent"]))
  }, [
    i("section", A, [
      a(i("div", M, [
        c(m, {
          class: "icon-upload",
          name: "upload-cloud"
        })
      ], 512), [
        [d, !l.uploadStarted && !l.fileName]
      ]),
      e[5] || (e[5] = n()),
      a(i("div", { class: "file-type" }, p(s.fileType), 513), [
        [d, l.uploadStarted]
      ])
    ]),
    e[16] || (e[16] = n()),
    a(i("section", G, [
      i("h4", E, p(r.label || o.i18n.messages["upload.label"]), 1),
      e[6] || (e[6] = n()),
      i("h6", P, p(r.instructions || o.i18n.messages["upload.instructions"]), 1),
      e[7] || (e[7] = n()),
      i("h6", K, p(r.allowedFilesLabel || o.i18n.messages["upload.allowable"]), 1)
    ], 512), [
      [d, !l.uploadStarted && !l.fileName]
    ]),
    e[17] || (e[17] = n()),
    a(i("section", U, [
      i("form", j, [
        i("input", {
          ref: "fileInput",
          type: "file",
          accept: r.accept,
          onChange: e[0] || (e[0] = (...f) => s.handleSelection && s.handleSelection(...f))
        }, null, 40, O)
      ], 512),
      e[13] || (e[13] = n()),
      i("div", q, [
        i("span", null, [
          a(i("span", H, [
            i("span", J, p(s.shortFileName), 1),
            e[8] || (e[8] = n()),
            a(i("span", null, "." + p(s.fileType), 513), [
              [d, s.fileType]
            ])
          ], 512), [
            [d, !l.error]
          ]),
          e[9] || (e[9] = n()),
          a(i("span", { class: "error-message" }, p(l.errorMessage), 513), [
            [d, l.error]
          ])
        ]),
        e[10] || (e[10] = n()),
        i("span", Q, p(s.fileSizeLabel), 1)
      ]),
      e[14] || (e[14] = n()),
      i("div", R, [
        c(F, {
          indeterminate: !l.complete && !l.error,
          value: 100
        }, null, 8, ["indeterminate"])
      ]),
      e[15] || (e[15] = n()),
      a(i("section", W, [
        a(i("div", null, [
          c(m, {
            class: "icon-checkmark",
            name: "check"
          }),
          e[11] || (e[11] = n()),
          i("span", null, p(r.uploadCompleteLabel || o.i18n.messages["upload.complete.label"]), 1)
        ], 512), [
          [d, l.success]
        ]),
        e[12] || (e[12] = n()),
        a(i("div", null, [
          c(m, {
            class: "icon-alert-circle",
            name: "alert-circle"
          })
        ], 512), [
          [d, l.error]
        ])
      ], 512), [
        [d, l.uploadStarted]
      ])
    ], 512), [
      [d, l.uploadStarted]
    ]),
    e[18] || (e[18] = n()),
    l.uploadStarted || l.fileName ? (g(), T(D, {
      key: 0,
      fill: "",
      class: "header"
    }, {
      default: S(() => [
        c(y, { padding: "spacing-100" }, {
          default: S(() => [
            c(B, {
              name: "x",
              onClick: h(s.reset, ["stop"])
            }, null, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })) : x("", !0)
  ], 34);
}
const ue = /* @__PURE__ */ I(V, [["render", X], ["__scopeId", "data-v-64eb3cf3"]]);
export {
  ue as default
};
//# sourceMappingURL=design-system.es55.js.map
